module.exports = __webpack_public_path__ + "img/inspiracao.ff7cb122.jpg";